module.exports = __webpack_public_path__ + "img/dashboard.380f22c5.png";